import api from '../services/api';
import { IProduct } from '../shared/interfaces';

interface IResponseGetProducts {
  data: IProduct[];
  count: number;
}
export const getProducts = async (
  take: number,
  skip: number,
  keyword?: string,
): Promise<IResponseGetProducts> => {
  const response = await api.post('/products/list', {
    take,
    skip,
    keyword,
  });
  return response.data;
};

export const postProduct = async (payload: any): Promise<IProduct> => {
  const response = await api.post(`/products`, payload);
  return response.data;
};

export const patchProduct = async (
  id: string | undefined,
  payload: any,
): Promise<IProduct> => {
  if (!id) {
    throw new Error('ID do produto não fornecido.');
  }
  const response = await api.patch(`/products/${id}`, payload);
  return response.data;
};

export interface IQuickSaleResponse {
  sale_id?: string;
  financials: Array<{
    id?: string;
    code?: number;
    issue_date: string;
    due_date: string;
    client_id: string;
    description: string;
    value: number;
    type: number;
    number_doc?: string;
    payment?: string;
    created_by?: string;
  }>;
}

export const postProductQuickSale = async (
  payload: any,
): Promise<IQuickSaleResponse> => {
  const response = await api.post('/products/quick-sale', payload);
  return response.data;
};
